<template>
    <v-card>
        <!-- Toolbar del dialog -->
        <v-toolbar dense color="indigo">
            <v-toolbar-title class="white--text">
                Etichette Generate
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <!-- Bottone di chiusura -->
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
                        <v-icon color="error"> mdi-close </v-icon>
                    </v-btn>
                </template>
                <span>Chiudi</span>
            </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
            <v-row align="center" justify="center">
                <v-col
                    cols="4"
                    v-for="(elem, i) in items_risme_etichette"
                    :key="i"
                >
                    <!-- Sezione della miniatura + cod_report -->
                    <div>
                        <!-- Sezione della miniatura -->
                        <div>
                            <v-icon
                                @click="showPdfViewer(elem)"
                                color="error"
                                x-large
                                style="font-size: 100px"
                            >
                                mdi-file-pdf-box
                            </v-icon>
                        </div>
                        <!-- Sezione del cod_report -->
                        <div>
                            <span>
                                <b>{{ elem.des }}</b>
                            </span>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-card-text>

        <!-- Overlay di caricamento -->
        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <!-- Snackbar -->
        <SnackbarQV ref="SnackbarQV" />

        <!-- Overlay -->
        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
    name: "StampaReportSeriali",
    components: {
        SnackbarQV,
    },
    props: {
        id_report_custom: {
            type: Number,
            default: null,
        },
        seriali: {
            type: Array,
            default: () => [],
        },
        visible: {
            type: Boolean,
            default: false,
        },
        workorder: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            // Variabili
            iframeUrl: null,
            selected_pdf: null,

            // Modal
            dialog_risme_etichette: false,
            loading: false,

            // Array
            items_risme_etichette: new Array(),
        };
    },
    methods: {
        b64toBlob(b64Data, sliceSize = 512) {
            const byteCharacters = atob(b64Data);
            const byteArrays = [];
            for (
                let offset = 0;
                offset < byteCharacters.length;
                offset += sliceSize
            ) {
                const slice = byteCharacters.slice(offset, offset + sliceSize);

                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }

            const blob = new Blob(byteArrays, { type: "application/pdf" });
            return blob;
        },
        chiudiDialogConferma() {
            this.dialog_conferma_contenitore = false;
        },
        clickChiudi() {
            this.$emit("chiudi");
        },
        formatData(arg) {
            if (arg == null || arg == "") {
                return "N/D";
            } else {
                let strRes = "";
                strRes += arg.substr(8, 2);
                strRes += "/";
                strRes += arg.substr(5, 2);
                strRes += "/";
                strRes += arg.substr(0, 4);
                return strRes;
            }
        },
        getReportPdf() {
            this.items_risme_etichette = new Array();

            // Conto quante request sto per inviare.
            const num_request = this.seriali.length;
            let num_response = 0;

            this.loading = true;
            this.seriali.forEach((s) => {
                const request = {
                    controller: "global",
                    method: "POST",
                    richiesta: {
                        action: "getreportpdf",
                        token: localStorage.user_token,
                        id_report:
                            this.id_report_custom != null
                                ? this.id_report_custom
                                : this.workorder.id_report,
                        parametri: [
                            {
                                simbolo: "@id_articolo_packaging",
                                valore: this.workorder.id_articolo_packaging,
                            },
                            {
                                simbolo: "@id_magazzino_movimenti",
                                valore: s.id,
                            },
                            {
                                simbolo: "@cod_macchina",
                                valore: `${this.workorder.cod_macchina}`,
                            },
                            {
                                simbolo: "@cod_articolo",
                                valore: `${this.workorder.cod_articolo}`,
                            },
                            {
                                simbolo: "@quantita",
                                valore: `${this.workorder.quantita}`,
                            },
                            {
                                simbolo: "@cod_articolo_packaging",
                                valore: `${this.workorder.cod_contenitore}`,
                            },
                            {
                                simbolo: "@id_utente",
                                valore: `${this.workorder.id_personale}`,
                            },
                        ],
                    },
                };

                /* Se il WO ha anche un seriale_custom (come succede
                 *  per Insit), lo inserisco nella request. */
                if (this.workorder.seriale_custom) {
                    request.richiesta.parametri.push({
                        simbolo: "@seriale",
                        valore: `${this.workorder.seriale_custom}`,
                    });
                }

                // Inoltro la request.
                this.$store
                    .dispatch("api6", request)
                    .then((res) => {
                        num_response++;
                        if (
                            "tipo_messaggio" in res.data &&
                            "query_messaggio" in res.data &&
                            res.data.tipo_messaggio == 1
                        ) {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                res.data.query_messaggio
                            );
                        }
                        console.log(num_response, num_request);
                        if (num_response == num_request) {
                            this.loading = false;
                        }

                        if (res.status === 200) {
                            this.items_risme_etichette.push({
                                base64: res.data.result,
                            });
                        } else {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                "Errore di comunicazione col server, non  stato possibile salvare i dati."
                            );
                        }
                    })
                    .catch((err) => {
                        this.loading = false;
                        console.error(err);
                        if (
                            "tipo_messaggio" in err.response.data &&
                            "query_messaggio" in err.response.data &&
                            err.response.data.tipo_messaggio == 2
                        ) {
                            this.$refs.SnackbarQV.print(
                                "error",
                                err.response.data.query_messaggio
                            );
                        } else {
                            this.$refs.SnackbarQV.print(
                                "error",
                                "Errore di comunicazione col server"
                            );
                        }
                    });
            });
        },
        setItemSelezionato(arg) {
            this.items_imballi.forEach((e) => {
                if (e.id_articolo_packaging === arg.id_articolo_packaging) {
                    e.check = e.check === 1 ? 0 : 1;
                } else {
                    e.check = 0;
                }
            });

            this.key_checkbox = this.key_checkbox === 0 ? 1 : 0;
        },
        showPdfViewer(arg) {
            this.iframeUrl = arg.base64;
            const blob = this.b64toBlob(this.iframeUrl);
            const blob_url = URL.createObjectURL(blob);
            window.open(blob_url, "_blank");
        },
        showPreviewEtichette() {
            const request0 = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getseriale",
                    token: localStorage.user_token,
                    id_articolo_packaging: null,
                },
            };

            this.$store
                .dispatch("api", request0)
                .then(async (res0) => {
                    if (res0.status === 200) {
                        const res = JSON.parse(res0.data.result);

                        // Resetto l'array delle risme di etichette.
                        this.items_risme_etichette = new Array();

                        for (let i = 0; i < res.length; i++) {
                            await this.registraEStampa(res[i]);
                        }

                        this.dialog_risme_etichette = true;
                        this.loading = false;
                    } else {
                        this.loading = false;
                        this.$refs.SnackbarQV.print(
                            "orange",
                            "Errore di comunicazione col server, non è stato possibile ottenere i dati."
                        );
                    }
                })
                .catch((e) => {
                    this.loading = false;
                    console.error(e);
                    this.$refs.SnackbarQV.print(
                        "error",
                        "Errore di comunicazione col server, non è stato possibile ottenere i dati."
                    );
                });
        },
    },
    mounted() {},
    watch: {
        visible: {
            immediate: true,
            handler() {
                if (this.visible) {
                    this.getReportPdf();
                }
            },
        },
    },
};
</script>
<style scoped></style>
